import request from '@/utils/request'

export function sendSimpleMail(data) {
    return request({
        url: 'user/sendSimpleMail',
        method: 'post',
        data
    })
}

// 上传文件（图片等）
export function uploadFileFin(data) {
    return request({
        url: '/oss/uploadFileFin',
        method: 'post',
        data
    })
}